import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            storage: window.sessionStorage,
            paths: ["logged", "logo", "username"]
        })
    ],
    state: {
        logged: false,
        logoSponsor: null,
        logoPartner: null,
        reference: null,
        guest: null,
        zones: null,
        msgRegister: null,
        username: null,
        sponsor: null,
        partner: null,
        date: null
    },
    mutations: {
        login(state, data) {
            state.logoSponsor = data.logo;
            state.sponsor = data.partner;
            state.logged = true;
        },
        setUsername(state, username) {
            state.username = username;
        },
        updateCard(state, card) {
            state.logoPartner = card.logo;
            state.reference = card.reference;
            if (card.name === ' ')
                state.guest = '';
            else state.guest = card.name;
            state.zones = card.zones;
            state.partner = card.partner;
            state.date = card.date;
        },
        updateMsg(state, msg) {
            state.msgRegister = msg;
        },
        logout(state) {
            state.logged = false;
            state.logoSponsor = null;
            state.logoPartner = null;
            state.reference = null;
            state.guest = null;
            state.zones = null;
            state.msgRegister = null;
            state.username = null;
            state.sponsor = null;
            state.partner = null;
            state.date = null;
        }
    },
    actions: {
        login(context, data) {
            context.commit('login', data);
        },
        setUsername(context, username) {
            context.commit('setUsername', username);
        },
        updateCard(context, card) {
            context.commit('updateCard', card);
        },
        updateMsg(context, msg) {
            context.commit('updateMsg', msg);
        },
        logout(context) {
            context.commit('logout');
        }
    },
    getters: {
        isLogged: state => {
            return state.logged;
        },
        logoSponsor: state => {
            return state.logoSponsor;
        },
        logoPartner: state => {
            return state.logoPartner;
        },
        sponsor: state => {
            return state.sponsor;
        },
        username: state => {
            return state.username;
        },
        zones: state => {
            return state.zones;
        },
        accessZones: state => {
            return state.zones;
        },
        reference: state => {
            return state.reference;
        },
        guest: state => {
            return state.guest;
        },
        partner: state => {
            return state.partner;
        },
        date: state => {
            return state.date;
        },
        msgRegister: state => {
            return state.msgRegister;
        }
    }
})
